<template>
  <transition type="animation" appear enter-active-class="animate__animated animate__fadeIn" mode="out-in">
    <div v-if="temPermissao('segmento-ensino-medio')" class="main pb-4" id="about-main">
      <b-container fluid="lg">
        <b-card no-body class="p-4 shadow-sm card__sistemacpv p-4">
          <b-nav class="nav-books" tabs fill>
            <b-nav-item :class="{ 'disabled': menu.id === 4, 'active': activeIndex === index }"
              :active="activeIndex === index" @click.prevent="activeIndex === index ? null : ''"
              v-b-toggle="'collapse-' + index" v-for="(menu, index) in lists" :key="index">
              <i :class="menu.iconClass"></i>
              <span class="mr-auto">{{ menu.name }}</span>
            </b-nav-item>
          </b-nav>
          <div v-for="(menu, index) in lists" :key="'collapse-' + index">
            <b-collapse :id="'collapse-' + index" @show="setActive(index)" @hide="clearActive(index)"
              :visible="activeIndex === index">
              <div class="mt-3" v-if="menu.turmas"></div>
              <div class="mt-3" v-else>
                <b-card no-body class="mt-2 border-0 shadow-none">
                  <b-row v-if="menu.books">
                    <b-col cols="12" v-for="(book, i) in menu.books" :key="i" class="mt-2">
                      <router-link :to="{
                        name: 'render-conteudo-exclusivo',
                        params: { paramsForUrl: book.linkFree || '', nomeApostila: book.name || '' },
                        query: { material: formatParam(book.description) }
                      }">
                        <b-card no-body class="p-3 text-dark">
                          <div class="d-flex aling-items-center">
                            <i :class="book.iconClass" class="d-flex align-items-center"></i>
                            <span>{{ book.name }}</span>
                          </div>
                        </b-card>
                      </router-link>
                    </b-col>
                  </b-row>
                  <div v-else>
                    <div class="d-flex align-items-center justify-content-center">
                      <EstatisticasEnem />
                    </div>
                  </div>
                </b-card>
              </div>
            </b-collapse>
          </div>
        </b-card>
      </b-container>
    </div>
    <div v-else>
      <div class="container">
        <div class="text-center">
          {{ error503 }}
          <p>Você não tem permissão para visualizar este conteúdo.</p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'dash-infantil',
  components: { EstatisticasEnem: () => import('./EstatisticasEnem.vue') },

  data() {
    return {
      pageTitle: 'ENEM',
      pageSubtitle: '',

      NamePermission: '',
      IndexPermission: '',

      activeIndex: 0,

      lists: [
        {
          id: 1,
          name: 'Coleção CPV',
          iconClass: 'fa-solid fa-book fa-sm mr-1',
          link_name: 'enem-colecao-cpv',
          colorCard: {
            'background-color': '#38aaf3',
            'border:': '1px solid #38aaf3',
            'border-radius': '0.5rem',
          },
          permission: 'segmento-enem',
          bg__link: 'infantil',
          books: [
            {
              linkReaOnly: '',
              iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
              linkFree: 'enem/cadernos-digitais/ENEM-0021_MIOLO-Book-_-Ciencias-da-Natureza.pdf',
              videoId: '',
              src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/enem/base-enem.png',
              bundle: '',
              name: 'Ciências da Natureza e suas Tecnologias',
              segment: '',
              discipline: '',
              description: 'ciencias-da-natureza',
              toolTip: ' ',
              isbn: 'Teoria + Provas presenciais + PPL + Online  ',
            },
            {
              linkReaOnly: '',
              iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
              linkFree: 'enem/cadernos-digitais/ENEM-0023_MIOLO-Book-_-Ciencias-Humanas.pdf',
              videoId: '',
              src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/enem/base-enem.png',
              bundle: '',
              name: 'Ciências Humanas e suas Tecnologias',
              segment: '',
              discipline: '',
              description: 'ciencias-humanas',
              toolTip: ' ',
              isbn: 'Teoria + Provas presenciais + PPL + Online  ',
            },
            {
              linkReaOnly: '',
              iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
              linkFree: 'enem/cadernos-digitais/ENEM-0022_MIOLO-Book-_-Linguagens-e-Codigos.pdf',
              videoId: '',
              src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/enem/base-enem.png',
              bundle: '',
              name: 'Linguagens e Códigos e suas Tecnologias',
              segment: '',
              discipline: '',
              description: 'linguagens-e-codigos',
              toolTip: ' ',
              isbn: 'Teoria + Provas presenciais + PPL + Online  ',
            },
            {
              linkReaOnly: '',
              iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
              linkFree: 'enem/cadernos-digitais/ENEM-0020_MIOLO-Book-_-Matematica.pdf',
              videoId: '',
              src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/enem/base-enem.png',
              bundle: '',
              name: 'Matemática e suas Tecnologias',
              segment: '',
              discipline: '',
              description: 'matematica',
              toolTip: ' ',
              isbn: 'Teoria + Provas presenciais + PPL + Online  ',
            },
          ]
        },
        {
          id: 2,
          name: 'Estatística',
          iconClass: 'fa-solid fa-chart-pie fa-sm mr-1',
          link_name: 'enem-estatisca',
          colorCard: {
            'background-color': '#4ac8aa',
            'border:': '1px solid #4ac8aa',
            'border-radius': '0.5rem',
          },
          permission: 'segmento-enem',
          bg__link: 'fundamental-i',
        },
        {
          id: 3,
          name: 'Manual',
          iconClass: 'fa-solid fa-notebook fa-sm mr-1',
          link_name: 'enem-manual',
          colorCard: {
            'background-color': '#a7dc48',
            'border:': '1px solid #a7dc48',
            'border-radius': '0.5rem',
          },
          permission: 'segmento-enem',
          bg__link: 'fundamental-ii',
          books: [
            {
              linkReaOnly: '',
              iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
              linkFree: 'enem/manuais/manual-coodenador.pdf',
              videoId: '',
              src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/base-fund1-manual-coordenador.png',
              bundle: '',
              name: 'Manual de Orientações para o Coordenador',
              segment: '1,2,3',
              discipline: '',
              description: 'Manual de Orientações',
              toolTip: '',
              isbn: 'Manual',
            },
            {
              linkReaOnly: '',
              iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
              linkFree: 'enem/manuais/2020-_-enem-_-teoria-e-exercicios-_-gramatica-e-texto-1.pdf',
              videoId: '',
              src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/enem/base-enem-manual-p.png',
              bundle: '',
              name: 'Teoria & Exercícios - Gramática e Texto',
              segment: 'enem',
              discipline: 'Linguagens, Códigos e suas Tecnologias',
              description: 'teoria & exercicios gramatica e texto',
              toolTip: '',
              isbn: 'Manual',
            },
            {
              linkReaOnly: '',
              iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
              linkFree: 'enem/manuais/2020-_-enem-_-teoria-e-exercicios-_-literatura-1.pdf',
              videoId: '',
              src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/enem/base-enem-manual-p.png',
              bundle: '',
              name: 'Teoria & Exercícios - Literatura',
              segment: 'enem',
              discipline: 'Linguagens, Códigos e suas Tecnologias',
              description: 'teoria & exercicios literatura',
              toolTip: '',
              isbn: 'Manual',
            },
            {
              linkReaOnly: '',
              iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
              linkFree: 'enem/manuais/2020-_-enem-_-teoria-e-exercicios-_-redacao-1.pdf',
              videoId: '',
              src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/enem/base-enem-manual-p.png',
              bundle: '',
              name: 'Teoria & Exercícios - Redação',
              segment: 'enem',
              discipline: 'Linguagens, Códigos e suas Tecnologias',
              description: 'teoria & exercicios redacao',
              toolTip: '',
              isbn: 'Manual',
            },
            {
              linkReaOnly: '',
              iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
              linkFree: 'enem/manuais/2020-_-enem-_-teoria-e-exercicios-_-arte-1.pdf',
              videoId: '',
              src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/enem/base-enem-manual-p.png',
              bundle: '',
              name: 'Teoria & Exercícios - Arte',
              segment: 'enem',
              discipline: 'Linguagens, Códigos e suas Tecnologias',
              description: 'teoria & exercicios arte',
              toolTip: '',
              isbn: 'Manual',
            },
            {
              linkReaOnly: '',
              iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
              linkFree: 'enem/manuais/2020-_-enem-_-teoria-e-exercicios-_-ingles-1.pdf',
              videoId: '',
              src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/enem/base-enem-manual-p.png',
              bundle: '',
              name: 'Teoria & Exercícios - Inglês',
              segment: 'enem',
              discipline: 'Linguagens, Códigos e suas Tecnologias',
              description: 'teoria & exercicios ingles',
              toolTip: '',
              isbn: 'Manual',
            },
            {
              linkReaOnly: '',
              iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
              linkFree: 'enem/manuais/2020-_-enem-_-teoria-e-exercicios-_-espanhol-1.pdf',
              videoId: '',
              src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/enem/base-enem-manual-y.png',
              bundle: '',
              name: 'Teoria & Exercícios - Espanhol',
              segment: 'enem',
              discipline: 'Linguagens, Códigos e suas Tecnologias',
              description: 'teoria & exercicios espanhol',
              toolTip: '',
              isbn: 'Manual',
            },
            {
              linkReaOnly: '',
              iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
              linkFree: 'enem/manuais/2020-_-enem-_-teoria-e-exercicios-_-matematica-1.pdf',
              videoId: '',
              src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/enem/base-enem-manual-y.png',
              bundle: '',
              name: 'Teoria & Exercícios - Matemática',
              segment: 'enem',
              discipline: 'Matemática e suas Tecnologias',
              description: 'teoria & exercicios matematica',
              toolTip: '',
              isbn: 'Manual',
            },
            {
              linkReaOnly: '',
              iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
              linkFree: 'enem/manuais/2020-_-enem-_-teoria-e-exercicios-_-hg-1.pdf',
              videoId: '',
              src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/enem/base-enem-manual-r.png',
              bundle: '',
              name: 'Teoria & Exercícios - História Geral',
              segment: 'enem',
              discipline: 'Ciências Humanas e suas Tecnologias',
              description: 'teoria & exercicios historia geral',
              toolTip: '',
              isbn: 'Manual',
            },
            {
              linkReaOnly: '',
              iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
              linkFree: 'enem/manuais/2020-_-enem-_-teoria-e-exercicios-_-hb-1.pdf',
              videoId: '',
              src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/enem/base-enem-manual-r.png',
              bundle: '',
              name: 'Teoria & Exercícios - História do Brasil',
              segment: 'enem',
              discipline: 'Ciências Humanas e suas Tecnologias',
              description: 'teoria & exercicios historia do brasil',
              toolTip: '',
              isbn: 'Manual',
            },
            {
              linkReaOnly: '',
              iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
              linkFree: 'enem/manuais/2020-_-enem-_-teoria-e-exercicios-_-geografia-1.pdf',
              videoId: '',
              src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/enem/base-enem-manual-r.png',
              bundle: '',
              name: 'Teoria & Exercícios - Geografia',
              segment: 'enem',
              discipline: 'Ciências Humanas e suas Tecnologias',
              description: 'teoria & exercicios geografia',
              toolTip: '',
              isbn: 'Manual',
            },
            {
              linkReaOnly: '',
              iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
              linkFree: 'enem/manuais/2020-_-enem-_-teoria-e-exercicios-_-filosofia-1.pdf',
              videoId: '',
              src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/enem/base-enem-manual-y.png',
              bundle: '',
              name: 'Teoria & Exercícios - Filosofia',
              segment: 'enem',
              discipline: 'Ciências Humanas e suas Tecnologias',
              description: 'teoria & exercicios filosofia',
              toolTip: '',
              isbn: 'Manual',
            },
            {
              linkReaOnly: '',
              iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
              linkFree: 'enem/manuais/2020-_-enem-_-teoria-e-exercicios-_-fisica-1.pdf',
              videoId: '',
              src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/enem/base-enem-manual-c.png',
              bundle: '',
              name: 'Teoria & Exercícios - Física',
              segment: 'enem',
              discipline: 'Ciências Humanas e suas Tecnologias',
              description: 'teoria & exercicios fisica',
              toolTip: '',
              isbn: 'Manual',
            },
            {
              linkReaOnly: '',
              iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
              linkFree: 'enem/manuais/2020-_-enem-_-teoria-e-exercicios-_-sociologia-1.pdf',
              videoId: '',
              src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/enem/base-enem-manual-r.png',
              bundle: '',
              name: 'Teoria & Exercícios - Sociologia',
              segment: 'enem',
              discipline: 'Ciências Humanas e suas Tecnologias',
              description: 'teoria & exercicios sociologia',
              toolTip: '',
              isbn: 'Manual',
            },
            {
              linkReaOnly: '',
              iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
              linkFree: 'enem/manuais/2020-_-enem-_-teoria-e-exercicios-_-biologia-1.pdf',
              videoId: '',
              src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/enem/base-enem-manual-c.png',
              bundle: '',
              name: 'Teoria & Exercícios - Biologia',
              segment: 'enem',
              discipline: 'Ciências da Natureza e suas Tecnologias',
              description: 'teoria & exercicios biologia',
              toolTip: '',
              isbn: 'Manual',
            },
            {
              linkReaOnly: '',
              iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
              linkFree: 'enem/manuais/2020-_-enem-_-teoria-e-exercicios-_-quimica-1.pdf',
              videoId: '',
              src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/enem/base-enem-manual-c.png',
              bundle: '',
              name: 'Teoria & Exercícios - Química',
              segment: 'enem',
              discipline: 'Ciências da Natureza e suas Tecnologias',
              description: 'teoria & exercicios quimica',
              toolTip: '',
              isbn: 'Manual',
            },
          ]
        },
      ],
    };
  },

  created() {
    this.$emit('update-header', {
      title: this.pageTitle,
      subtitle: this.pageSubtitle,
    });
  },

  computed: {
    permissions() {
      return this.$store.state.auth.userpermissions.permissions;
    },
    error503() {
      return (window.location.href = '/nao-autorizado');
    },
  },

  methods: {
    temPermissao(permissao) {
      return this.permissions.includes(permissao);
    },

    setActive(index) {
      this.activeIndex = index;
    },

    clearActive(index) {
      if (this.activeIndex === index) {
        this.activeIndex = 0;
      }
    },

    formatParam(param) {
      return param.replace(/\s+/g, '-');
    },
  },
};
</script>

<style scoped>
.main {
  margin-top: 30px;
}

.card_sistemacpv {
  border-radius: 8px;
  color: #3A1C53;
}
</style>
